import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@schibsted-svp/react-ui';
import { pick } from 'lodash';

import { createEditor, updateEditor } from '../services/api/editors';
import { CenteredSpinner } from '../components/CenteredSpinner/CenteredSpinner';
import { ContainerHeader } from '../components/Container/ContainerHeader/ContainerHeader';
import { EditorForm } from '../components/EditorForm/EditorForm';
import { useEditor } from '../hooks/useEditor';
import { withFetchStatus } from '../services/notifier';

import type { FC } from 'react';
import type { EditorResponse } from '../types';

export const Editor: FC = () => {
  const navigate = useNavigate();
  const { editorId } = useParams<{ editorId: string }>();
  const [editor, setEditor] = useState({} as EditorResponse);

  const {
    data: entity,
    isFetching,
    refetch,
  } = useEditor(editorId === 'new' ? undefined : editorId);

  useEffect(() => {
    if (entity) {
      setEditor(entity);
    }
  }, [entity]);

  async function onSubmit(data: EditorResponse) {
    const editorId = data.id;
    const fields = pick(data, ['name', 'image']);

    if (!editorId) {
      const editor = await withFetchStatus(createEditor, {
        success: 'Editor created',
        error: 'Failed to create editor',
      })(fields);

      navigate(`/editors/${editor.id}`, { replace: true });
    } else {
      await withFetchStatus(updateEditor, {
        success: 'Editor updated successfully',
        error: 'Failed to update editor',
      })(editorId, fields);
    }

    await refetch();
  }

  return (
    <Fragment>
      <ContainerHeader>
        <Link to="/editors">
          <Button type="button" variant="standard">
            Back to editors
          </Button>
        </Link>
      </ContainerHeader>
      {isFetching ? (
        <CenteredSpinner />
      ) : (
        <EditorForm editor={editor} onSubmit={onSubmit} />
      )}
    </Fragment>
  );
};
